// Publiczny hook dodania komentarza klienta - POST /sales-crm/public-offers/{token}/comments
// BEZ OAuth (uzywa publicAxios). Po sukcesie unieważnia query szczegolow oferty.

import publicAxios from 'api/publicAxios';
import { useMutation, useQueryClient, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { getPublicOfferQueryKey } from 'api/endpoints/useGetPublicOffer';

export interface IPostPublicOfferCommentPayload {
  comment: string;
}

const postPublicOfferComment = (
  token: string,
  payload: IPostPublicOfferCommentPayload
): Promise<ICommandResponseSuccess> =>
  publicAxios.post(`/sales-crm/public-offers/${token}/comments`, payload);

export const usePostPublicOfferComment = (
  token: string,
  options?: UseMutationOptions<ICommandResponseSuccess, IError, IPostPublicOfferCommentPayload>
) => {
  const queryClient = useQueryClient();

  return useMutation<ICommandResponseSuccess, IError, IPostPublicOfferCommentPayload>(
    (payload) => postPublicOfferComment(token, payload),
    {
      ...options,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(getPublicOfferQueryKey(token));
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
